const mundoIndie = [
	{
		path: '/agency/mundo-indie/workflow-status/list',
		name: 'agency-workflow-status-list',
		component: () => import('@/views/agency/workflow-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,mundo-indie',
		},
	},
	{
		path: '/agency/mundo-indie/game-status/list',
		name: 'agency-game-status-list',
		component: () => import('@/views/agency/game-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,mundo-indie',
		},
	},
	{
		path: '/agency/mundo-indie/goals/list',
		name: 'agency-goals-list',
		component: () => import('@/views/agency/goals/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,mundo-indie',
		},
	},
	{
		path: '/agency/mundo-indie/projects/list',
		name: 'agency-projects-list',
		component: () => import('@/views/agency/projects/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,mundo-indie',
		},
	},
	{
		path: '/agency/mundo-indie/testimonials/list',
		name: 'agency-testimonials-list',
		component: () => import('@/views/agency/project-testimonial/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,mundo-indie',
		},
	},
]

export default mundoIndie
